import React from 'react'
import HomeView from './homeView'
function index(props) {
    return <HomeView props={props} />
}

export default index
